import ConstantAPI from '@/config/ConstantAPI';
import { DataService } from '@/dataService/dataService';
import { checkResponse } from '@/util/common-utils';
import { MESSAGES } from '@/util/message-notification';
import { notification } from 'ant-design-vue';
import mutations from './mutations';
import { getField, updateField } from 'vuex-map-fields';
import { showConfirm } from '@/util/confirm';

const state = () => ({
  list: [],
  listAll: [],
  loading: false,
  detail: null,
  api: ConstantAPI.caseStudy,
  visible: false,
  action: null,
  listWebUrl: [],
});

const actions = {
  changeAction({ commit }, action) {
    commit('setAction', action);
  },
  async getAllWebUrl({ commit, state }) {
    try {
      commit('setLoading', true);
      const response = await DataService.callApi(state.api.GET_WEB_URL);
      return commit('setWebUrl', response.data);
    } catch (err) {
      console.log(err);
    }
  },
  async getAll({ commit, state }) {
    try {
      commit('setLoading', true);
      const response = await DataService.callApi(state.api.GET_ALL);
      return commit('setAll', response.data);
    } catch (err) {
      console.log(err);
    }
  },
  async create({ commit, state }, payload) {
    try {
      commit('setLoading', true);
      const response = await DataService.callApi(state.api.CREATE, payload);
      checkResponse(response, () => {
        notification.success({
          message: 'Thông báo',
          description: MESSAGES.MESSAGE_005,
          duration: 4,
        });
      });
      return commit('setLoading', false);
    } catch (err) {
      console.log(err);
    }
  },
  async getDetail({ commit, state }, code) {
    try {
      commit('setLoading', true);
      const response = await DataService.callApi({
        url: state.api.GET_BY_CODE.url + code,
        method: state.api.GET_BY_CODE.method,
      });
      commit('setData', response.data);
    } catch (err) {
      console.log(err);
    }
  },
  async update({ commit, state }, payload) {
    try {
      commit('setLoading', true);
      const response = await DataService.callApi(state.api.UPDATE, payload);
      checkResponse(response, () => {
        notification.success({
          message: 'Thông báo',
          description: MESSAGES.MESSAGE_007,
          duration: 4,
        });
      });
      return commit('setLoading', false);
    } catch (err) {
      console.log(err);
    }
  },
  async updateStatus({ commit, state }, payload) {
    try {
      commit('setLoading', true);
      const response = await DataService.callApi(
        state.api.UPDATE_STATUS,
        payload
      );
      checkResponse(response, () => {
        notification.success({
          message: 'Thông báo',
          description: MESSAGES.MESSAGE_007,
          duration: 4,
        });
      });
      return commit('setLoading', false);
    } catch (err) {
      console.log(err);
    }
  },
  async delete({ state }, rows) {
    try {
      if (await showConfirm('Bạn có chắc chắn muốn xóa không?')) {
        const response = await DataService.delete(
          state.api.DELETE.url + rows.map((e) => e.code).join(',')
        );
        let success = false;
        checkResponse(response, () => {
          success = true;
          notification.success({
            message: 'Thông báo',
            description: 'Xóa Case study thành công',
            duration: 4,
          });
        });
        return success;
      }
    } catch (err) {
      console.log(err);
    }
  },
  resetData({ state }) {
    state.detail = null;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations: {
    ...mutations,
    updateField,
  },
  getters: {
    getField,
  },
};
